module.exports = __webpack_public_path__ + "img/missingPhoto.6ca7f23d.png";